import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ClientBankruptcyControllerService } from './api/clientBankruptcyController.service';
import { ClientBusinessEntityControllerService } from './api/clientBusinessEntityController.service';
import { ClientCategoryControllerService } from './api/clientCategoryController.service';
import { ClientContractAnnouncementControllerService } from './api/clientContractAnnouncementController.service';
import { ClientContractNoticeControllerService } from './api/clientContractNoticeController.service';
import { ClientSaleControllerService } from './api/clientSaleController.service';
import { ManagementAutotagSettingsControllerService } from './api/managementAutotagSettingsController.service';
import { ManagementBankruptcyControllerService } from './api/managementBankruptcyController.service';
import { ManagementBusinessEntityControllerService } from './api/managementBusinessEntityController.service';
import { ManagementCategoryContractNoticesControllerService } from './api/managementCategoryContractNoticesController.service';
import { ManagementContractAnnouncementControllerService } from './api/managementContractAnnouncementController.service';
import { ManagementContractNoticeControllerService } from './api/managementContractNoticeController.service';
import { ManagementContractNoticesReportControllerService } from './api/managementContractNoticesReportController.service';
import { ManagementManualSchedulingControllerService } from './api/managementManualSchedulingController.service';
import { ManagementMediumContractNoticesControllerService } from './api/managementMediumContractNoticesController.service';
import { ManagementSaleControllerService } from './api/managementSaleController.service';
import { ManagementScreenshotControllerService } from './api/managementScreenshotController.service';
import { ManagementTagContractNoticesControllerService } from './api/managementTagContractNoticesController.service';
import { ManagementUploadControllerService } from './api/managementUploadController.service';
import { PublicBankruptcyControllerService } from './api/publicBankruptcyController.service';
import { PublicCategoryContractNoticesControllerService } from './api/publicCategoryContractNoticesController.service';
import { PublicContractNoticeControllerService } from './api/publicContractNoticeController.service';
import { PublicSaleControllerService } from './api/publicSaleController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ClientBankruptcyControllerService,
    ClientBusinessEntityControllerService,
    ClientCategoryControllerService,
    ClientContractAnnouncementControllerService,
    ClientContractNoticeControllerService,
    ClientSaleControllerService,
    ManagementAutotagSettingsControllerService,
    ManagementBankruptcyControllerService,
    ManagementBusinessEntityControllerService,
    ManagementCategoryContractNoticesControllerService,
    ManagementContractAnnouncementControllerService,
    ManagementContractNoticeControllerService,
    ManagementContractNoticesReportControllerService,
    ManagementManualSchedulingControllerService,
    ManagementMediumContractNoticesControllerService,
    ManagementSaleControllerService,
    ManagementScreenshotControllerService,
    ManagementTagContractNoticesControllerService,
    ManagementUploadControllerService,
    PublicBankruptcyControllerService,
    PublicCategoryContractNoticesControllerService,
    PublicContractNoticeControllerService,
    PublicSaleControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
